import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import PitchItForm from "../components/pitchItForm/PitchItForm";
import * as projectActions from "./../../../../../actions/project.actions";
import * as commonActions from "./../../../../../actions/common.actions";
import * as tableActions from "./../../../../../actions/table.actions";

class PitchItContainer extends Component {
  constructor(props) {
    super(props);

    this.storePitch = this.storePitch.bind(this);
    this.updatePitch = this.updatePitch.bind(this);
    this.errorOverlay = this.errorOverlay.bind(this);
  }

  componentDidMount() {
    this.props.projectActions.getMatch(this.props.match.params.matchId);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.projectMatch != this.props.projectMatch) {
      const status = _.get(this.props, "projectMatch.project.status_id");

      if (status !== 5 && status !== 6) {
        this.props.commonActions.showError(" ");
      }
    }
  }

  componentWillUnmount() {
    this.props.commonActions.showError(null);
  }

  errorOverlay = () => {
    this.props.history.push("/member/projects/matches");
  };

  storePitch(form) {
    const payload = {
      match_id: this.props.match.params.matchId,
      pitch: form.pitch
    };

    this.props.projectActions.storePitch(payload);
  }

  updatePitch(form) {
    const payload = {
      pitch: form.pitch
    };

    this.props.projectActions.updatePitch(
      this.props.projectMatch.pitch.id,
      `/member/project/${this.props.projectMatch.project_id}/messages`,
      payload
    );
  }

  render() {
    const match = this.props.projectMatch;
    const pitch = _.get(match, "pitch");

    return (
      <PitchItForm
        common={this.props.common}
        errorOverlay={this.errorOverlay}
        onSubmit={pitch ? this.updatePitch : this.storePitch}
      />
    );
  }
}

const mapStateToProps = state => {
  return {
    project: state.project,
    projectMatch: state.project.match,
    common: state.common
  };
};

const mapDispatchToProps = dispatch => {
  return {
    projectActions: bindActionCreators(projectActions, dispatch),
    commonActions: bindActionCreators(commonActions, dispatch),
    tableActions: bindActionCreators(tableActions, dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PitchItContainer);



// WEBPACK FOOTER //
// ./src/routes/candidate/projects/matches/containers/PitchItContainer.js